export default "__VITE_ASSET__478e17a3__"